import { createRouter, createWebHistory } from 'vue-router'
import cookie from 'cookie.js'
import { routes as frontRoutes } from './front'
import { routes as workbenchRoutes } from './workbench'

const routes = [...frontRoutes, workbenchRoutes]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

router.beforeEach(async (to, from) => {
    const accessToken = cookie.get('accessToken')
    to.path.startsWith('/workbench')
    if (
        !accessToken &&
        to.path.startsWith('/workbench') &&
        to.name !== 'login'
    ) {
        // 将用户重定向到登录页面
        return { name: 'login', query: {path: encodeURIComponent(to.fullPath)}}
    }
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})


export default router

